import { render, staticRenderFns } from "./Error403.vue?vue&type=template&id=365d5182&"
import script from "./Error403.vue?vue&type=script&lang=js&"
export * from "./Error403.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('365d5182')) {
      api.createRecord('365d5182', component.options)
    } else {
      api.reload('365d5182', component.options)
    }
    module.hot.accept("./Error403.vue?vue&type=template&id=365d5182&", function () {
      api.rerender('365d5182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/errors/screens/Error403.vue"
export default component.exports